module.exports = __webpack_public_path__ + "img/guia_paso_a_paso.c58bf06d.png";